<template>
  <AuthView title="Admin Panel">
    <div class="flex col gap-5">
      <AppLink to="/admin/send">
        <AppBtn prepend-icon="mdi:email-outline" size="x-large">
          Visa Send
        </AppBtn>
      </AppLink>

      <AppLink to="/admin/forms">
        <AppBtn prepend-icon="mdi:file-document-check-outline" size="x-large">
          Forms
        </AppBtn>
      </AppLink>

      <AppLink to="/admin/fix">
        <AppBtn prepend-icon="mdi:bug-outline" size="x-large">
          Fix Request
        </AppBtn>
      </AppLink>

      <AppLink to="/admin/products">
        <AppBtn prepend-icon="mdi:package-variant-closed" size="x-large">
          Products
        </AppBtn>
      </AppLink>

      <AppLink to="/admin/emails">
        <AppBtn prepend-icon="mdi:list-box-outline" size="x-large">
          Emails
        </AppBtn>
      </AppLink>

      <AppLink to="/admin/coupons">
        <AppBtn prepend-icon="mdi:coupon-outline" size="x-large">
          Coupons
        </AppBtn>
      </AppLink>

      <AppLink to="/admin/email-preview">
        <AppBtn prepend-icon="mdi:mail-outline" size="x-large">
          Email Preview
        </AppBtn>
      </AppLink>
    </div>
  </AuthView>
</template>

<script setup lang="ts">
definePageMeta({ middleware: 'admin' });
</script>

<style scoped>
a {
  width: min-content;
}
</style>